var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgClaimSymbolEco = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 60,
    viewBox: "0 0 64 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2607_225581)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2607_225581",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 60,
    rx: 6,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2607_225581)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 53,
    r: 49,
    fill: "#2DB875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9367 7.51968C56.8067 7.20521 56.5 7.00008 56.1597 7C23.5319 7 20 20.5251 20 26.3408C20 33.8854 25.7452 38.9544 34.2957 38.9544C45.0948 38.9544 47.3569 28.6785 48.5711 23.1571C49.7516 17.5368 52.6037 12.4048 56.7533 8.43456C56.9936 8.19458 57.0659 7.83368 56.9367 7.51968Z",
    fill: "#3CD58B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8409 44.0012C20.3765 44.0012 20 43.6246 20 43.1602C20 38.1602 28.6699 22.1174 42.3383 15.4945C42.7562 15.292 43.2592 15.4666 43.4618 15.8846C43.6642 16.3026 43.4896 16.8056 43.0716 17.0081C29.2687 23.6967 21.6818 39.2299 21.6818 43.1603C21.6818 43.6247 21.3054 44.0012 20.8409 44.0012Z",
    fill: "#62EFAB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2607_225581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 60,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClaimSymbolEco);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/claim-symbol-eco.8a52ffa8cb23f0bf64c2b3ff8da9c810.svg";